const eventTypeConstant = {
  EVENT_TYPE_API_TYPES: {
    ADD_EVENT_TYPE: "ADD_EVENT_TYPE",
    GET_PARTNER_EVENT_TYPES: "GET_PARTNER_EVENT_TYPES",
    GET_ADMIN_EVENT_TYPES: "GET_ADMIN_EVENT_TYPES",
    UPDATE_PARTNER_EVENT_TYPE: "UPDATE_PARTNER_EVENT_TYPE",
    GET_PARTNER_EVENT_TYPE_DETAIL: "GET_PARTNER_EVENT_TYPE_DETAIL",
    UPDATE_ADMIN_EVENT_TYPE: "UPDATE_ADMIN_EVENT_TYPE",
    GET_ADMIN_EVENT_TYPE_DETAIL: "GET_ADMIN_EVENT_TYPE_DETAIL",
    ENABLE_DISABLE_EVENT_TYPE_GAME: "ENABLE_DISABLE_EVENT_TYPE_GAME",
  },
  UNITS: [
    {
      value: "1",
      label: "Duration",
    },
    {
      value: "2",
      label: "Currency",
    },
    {
      value: "3",
      label: "Occurrence",
    },
    {
      value: "4",
      label: "Partner specific",
    },
  ],
  PARTNER_TAB: {
    TAB1: {
      title: "My Event Types",
      tab: "MY_EVENT_TYPE",
    },
    TAB2: {
      title: "QX Event Types",
      tab: "QX_EVENT_TYPE",
    },
  },

  ADMIN_TAB: {
    TAB1: {
      title: "System",
      tab: "SYSTEM_EVENT_TYPE",
    },
    TAB2: {
      title: "Partner Defined",
      tab: "PARTNER_EVENT_TYPE",
    },
  },
};

export default eventTypeConstant;
